'use strict';
const mmWidgets = require('./mm-widgets'),
	cognitoUsernameForLicense = require('../models/cognito-username-for-license');

const { trackEvent } = require('../start/ga-consent');
require('./section-handler-widget');
require('./show-progress-message');
require('./display-error');
require('./show-error');
mmWidgets.fn.cognitoSetPasswordWidget = function (cognitoApi, authenticationModel, cognitoModel) {
	return mmWidgets.each(this, function () {
		const widget = this.sectionHandlerWidget(),
			passwordFormSection = widget.find('[data-mm-section~=password-form]'),
			resetPasswordButton = widget.find('[data-mm-role~="cognito-reset-password"]'),
			requestValidationCodeButton = widget.find('[data-mm-role~="cognito-request-validation-code"]'),
			passwordField = widget.find('[name="cognito-password"]'),
			passwordRetypeField = widget.find('[name="cognito-password-retype"]'),
			verificationCodeField = widget.find('[name="cognito-password-verify"]'),
			verificationEmailSpan = widget.find('[data-mm-role~="cognito-sent-to-email"]'),
			cleanup = function () {
				passwordField.val('');
				passwordRetypeField.val('');
				verificationCodeField.val('');
				verificationEmailSpan.text('');
			};

		widget.on('show', function () {
			cleanup();
			widget.showSection('initial');
		});
		widget.on('hide', function () {
			cleanup();
		});

		requestValidationCodeButton.click(() => {
			return authenticationModel.getProfile().then(profile => {
				return cognitoUsernameForLicense(profile.license);
			}).then(username => {
				widget.displayError();
				widget.showProgressMessage('Requesting validation code, please wait...');
				return cognitoApi.requestPasswordReset(username);
			}).then((response) => {
				if (response && response.maskedEmail) {
					widget.find('[data-mm-role~="cognito-sent-to-email"]').text(response.maskedEmail);
					trackEvent({
						action: 'validation_code_requested',
						purpose: 'set_password',
						method: 'email'
					});
				}
				widget.showSection('password-form');
			})
			.catch((reason) => widget.showError(reason))
			.then(() => widget.trigger('click-complete'));
		});

		resetPasswordButton.click(function () {
			const password = passwordField.val(),
				passwordRetype = passwordRetypeField.val(),
				verificationCodeRaw = verificationCodeField.val(),
				verificationCode = verificationCodeRaw && verificationCodeRaw.trim && verificationCodeRaw.trim();
			let hasErrors = false;
			passwordFormSection.displayError();
			if (!verificationCode) {
				passwordFormSection.displayError('no-cognito-verification-code', hasErrors);
				hasErrors = true;
			}
			if (!password) {
				passwordFormSection.displayError('no-cognito-password', hasErrors);
				hasErrors = true;
			} else if (password !== passwordRetype) {
				passwordFormSection.displayError('cognito-password-mismatch', hasErrors);
				hasErrors = true;
			}
			if (hasErrors) {
				widget.trigger('click-complete');
				return;
			}
			widget.showProgressMessage('Resetting password, please wait...');
			return cognitoApi.completePendingUserAction(password, verificationCode)
			.then(() => {
				cognitoModel.sendContext();
				widget.showSection('complete');
				trackEvent({
					action: 'password_set',
					status: 'success',
					method: 'email'
				});
			})
			.catch(err => {
				passwordFormSection.displayError(err || 'cognito-set-password-failed');
				widget.showSection('password-form');
			})
			.then(() => widget.trigger('click-complete'));

		});
	});

};

